<template>
  <div class="flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-receptionist"
      entity-name="工作人员"
      :add-btn="editable ? '添加' : false"
      hide-show-detail
      :data="create ? data : undefined"
      :before-update="create ? undefined : beforeUpdate"
      :custom-update="create ? customUpdate : undefined"
      :custom-delete="create ? customDelete : undefined"
      :custom-url="customUrl"
      :query="query"
      :action="action"
      :use-external="create"
      :columns="columns"
      :rules="rules">
      <template v-slot:title="{total}">
        共{{total}}条记录
        <span class="staff-tip">提示: 本列表为外部人员列表</span>
      </template>
      <template v-slot:button v-if="editable">
        <a-button @click="importStaff"><a-icon type="upload" />批量导入</a-button>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入姓名或手机号码查询"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入工作人员姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="tel">
          <a-input v-model="form.tel" placeholder="请输入工作人员手机号码"></a-input>
        </a-form-model-item>
      </template>
    </data-list>
    <batch-import-modal
      v-model="visible"
      name="工作人员导入模板.xlsx"
      url="https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/assets/activity/template/staff_template.xlsx"
      :import-url="create ? '/activity/activity/batch-upload' : '/activity/activity-receptionist/work-import'"
      :activity="activity.id * 1"
      @import="handleImport"></batch-import-modal>
  </div>
</template>

<script>
    import batchImportModal from "../../../components/batch-import-modal";
    import mixins from "../mixins";
    import {isEmpty} from "../../../common/js/tool";
    export default {
        name: "StaffSet",
        components: {
            batchImportModal
        },
        mixins: [mixins],
        props: {
            create: Boolean,
            list: Array
        },
        data() {
            return {
                columns: [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号码', dataIndex: 'tel'},
                ],
                rules: {
                    name: [{ required: true, message: '请输入工作人员姓名', trigger: 'blur' }],
                    tel: [
                        { required: true, message: '请输入工作人员手机号码', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ]
                },
                visible: false,
            }
        },
        computed: {
            activity() {
                return this.$store.getters.activity;
            },
            action() {
                return this.$route.meta.action;
            },
            query() {
                let res = '&filter[type]=2';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            },
            data: {
                get() {
                    return this.list ? [...this.list] : []
                },
                set(val) {
                    this.$emit("change", val);
                }
            }
        },
        methods: {
            customDelete(item, index) {
                this.$confirm({
                    title: '提示',
                    content: '确定删除此人员吗？',
                    onOk: () => {
                        const data = [...this.data];
                        data.splice(index, 1);
                        this.data = data;
                        this.$message.success('已删除');
                    }
                });
            },
            customUpdate(form, index, fn) {
                const data = [...this.data];
                if(isEmpty(index)) {
                    data.push({...form});
                } else {
                    data[index] = {...form};
                }
                this.data = data;
                fn();
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                    form.type = 2;
                }
                fn();
            },
            customUrl(form) {
                let res = '';
                if(form.keyword) {
                    res = `&filter[or][0][name][like]=${form.keyword}&filter[or][1][tel][like]=${form.keyword}`;
                }
                return res;
            },
            importStaff() {
                this.visible = true;
            },
            handleImport(list) {
                this.visible = false;
                if(this.create) {
                    if(list) {
                        const data = [...this.data];
                        list.forEach(item => data.push({name: item.name, tel: item.tel}));
                        this.data = data;
                    }
                } else {
                    this.$refs.dataList.getList();
                }
            },
        }
    }
</script>

<style scoped lang="less">
.staff-tip {
  margin-left: 1em;
  color: @error-color;
}
</style>
